import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectAll", "duplicateCheckbox", "combineButton"]

  connect() {
    this.updateCombineButton()
  }

  toggleAll() {
    const isChecked = this.selectAllTarget.checked
    
    this.duplicateCheckboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })
    
    this.updateCombineButton()
  }

  toggleIndividual() {
    this.updateSelectAllState()
    this.updateCombineButton()
  }

  updateSelectAllState() {
    const totalCheckboxes = this.duplicateCheckboxTargets.length
    const checkedCount = this.duplicateCheckboxTargets.filter(cb => cb.checked).length
    
    this.selectAllTarget.checked = checkedCount === totalCheckboxes
    this.selectAllTarget.indeterminate = checkedCount > 0 && checkedCount < totalCheckboxes
  }

  updateCombineButton() {
    const hasSelected = this.duplicateCheckboxTargets.some(cb => cb.checked)
    this.combineButtonTarget.disabled = !hasSelected
  }
}